import { listMenuItemSx } from 'components/styles/menu';
import { ListItemButton, ListItemText } from 'components/ui';
import { ProbelistLogoutIcon } from 'components/uiIcons';
import { FormattedMessage } from 'react-intl';
import { removeAuthenticated } from 'utils/authentication';
import useResourceMutation from 'hooks/use_resource_mutation';
import LogoutMutation from 'mutations/user/logout';

const LogoutButton = () => {
  const [logout, { loading }] = useResourceMutation(LogoutMutation, {
    onCompleted: () => removeAuthenticated(),
    errorKey: 'error.user.logout',
  });

  return (
    <ListItemButton sx={listMenuItemSx} onClick={logout} disabled={loading}>
      <ProbelistLogoutIcon aria-hidden="true" />
      <ListItemText>
        <FormattedMessage id="navbar.logout" />
      </ListItemText>
    </ListItemButton>
  );
};

export default LogoutButton;
